import Grid from './grid.js';
import ServersideGridRow from "./serverside_grid_row.js";
import ServersideGridPagination from "./serverside_grid_pagination.js";

class ServersideGrid extends Grid {
    make_head() {
		if (this.prevent_build) return;

		// labels
		if (this.header_row) {
			$(this.parent).find(".grid-heading-row .grid-row").remove();
		}
		this.header_row = new ServersideGridRow({
			parent: $(this.parent).find(".grid-heading-row"),
			parent_df: this.df,
			docfields: this.docfields,
			frm: this.frm,
			grid: this,
			configure_columns: true,
		});

		this.header_search = new ServersideGridRow({
			parent: $(this.parent).find(".grid-heading-row"),
			parent_df: this.df,
			docfields: this.docfields,
			frm: this.frm,
			grid: this,
			show_search: true,
		});
		this.header_search.wrapper.addClass("search-header-row");
		this.header_search.wrapper
			.find(".row-check")
			.append(`<i class="bi bi-search" style="width: fit-content; display: flex;font-size: 16px; font-weight: 700; color: #2d3e50;"></i>`);
		this.filter_applied && this.update_search_columns();
	}

	setup_grid_pagination() {
		this.grid_pagination = new ServersideGridPagination({
			grid: this,
			wrapper: this.wrapper,
		});
	}

	set_value(fieldname, value, doc) {
		let me = this
		if (this.display_status !== "None" && this.grid_rows_by_docname[doc.name]) {
			this.grid_rows_by_docname[doc.name].refresh_field(fieldname, value);
			frappe.call({
				method: "frappe.desk.search.save_child_item",
				args: {
					doc: this.grid_rows_by_docname[doc.name].doc
				},
				callback: function(r) {
				}
			}); 
		}
	}

	delete_rows() {
		let selected_children = this.get_selected_children();
		let me = this;
		if (selected_children && selected_children.length > 0){
			let doctype = selected_children[0].doctype;
			frappe.call({
				method: "frappe.desk.search.delete_docs_by_name",
				args: {
					doctype: doctype,
					names: selected_children.map(child => child.name)
				},
				callback: function(r) {
					me.get_data(1);
					me.refresh()
				}
			}); 
		}
		
	}

	get_selected_children() {
		return (this.grid_rows || [])
			.map((row) => {
				if(row){
					return row.doc.__checked ? row.doc : null;
				}
				else{
					return null;
				}
			})
			.filter((d) => {
				return d;
			});
	}

	setup_check() {
		this.wrapper.on("click", ".grid-row-check", (e) => {
			var $check = $(e.currentTarget);
			if ($check.parents(".grid-heading-row:first").length !== 0) {
				// select all?
				var checked = $check.prop("checked");
				$check
					.parents(".form-grid:first")
					.find(".grid-row-check")
					.prop("checked", checked);

				// set all
				let result_length = this.grid_pagination.get_result_length();
				let page_index = this.grid_pagination.page_index;
				let page_length = this.grid_pagination.page_length;
				for (var ri = 0; ri < result_length - (page_index - 1) * page_length; ri++) {
					this.grid_rows[ri].doc.__checked = checked ? 1 : 0;
				}
			} else {
				var docname = $check.parents(".grid-row:first").attr("data-name");
				this.grid_rows_by_docname[docname].select($check.prop("checked"));
			}
			this.refresh_remove_rows_button();
		});
	}
	

	delete_all_rows() {
		super.delete_rows()
		frappe.call({
			method: "frappe.desk.search.delete_all_children",
			args: {
				options: this.df.options,
				parent: this.df.parent,
				parenttype: this.df.parenttype,
				parentfield: this.df.parentfield,
			},
			callback: function(r) {
			}
		});
	}

	make() {
		let template = `
			<div class="grid-field">
				<label class="control-label">${__(this.df.label || "")}</label>
				<span class="help"></span>
				<p class="text-muted small grid-description"></p>
				<div class="grid-custom-buttons"></div>
				<div class="form-grid-container">
					<div class="form-grid">
						<div class="grid-heading-row"></div>
						<div class="grid-body" style="max-height: 351px;overflow-y: auto;">
							<div class="rows"></div>
							<div class="grid-empty text-center">
								<img
									src="/assets/frappe/images/ui-states/grid-empty-state.svg"
									alt="Grid Empty State"
									class="grid-empty-illustration"
								>
								${__("No Data")}
							</div>
						</div>
					</div>
				</div>
				<div class="small form-clickable-section grid-footer">
					<div class="flex justify-between">
						<div class="grid-buttons">
							<button class="btn btn-xs btn-danger grid-remove-rows hidden"
								data-action="delete_rows">
								${__("Delete")}
							</button>
						</div>
						<div class="grid-pagination">
						</div>
						<div class="grid-bulk-actions text-right">
							<button class="grid-download btn btn-xs btn-secondary hidden">
								${__("Download")}
							</button>
							<button class="grid-upload btn btn-xs btn-secondary hidden">
								${__("Upload")}
							</button>
						</div>
					</div>
				</div>
			</div>
		`;

		this.wrapper = $(template).appendTo(this.parent);
		$(this.parent).addClass("form-group");
		this.set_grid_description();
		this.set_doc_url();

		frappe.utils.bind_actions_with_object(this.wrapper, this);

		this.form_grid = this.wrapper.find(".form-grid");

		this.setup_add_row();

		this.setup_grid_pagination();

		this.custom_buttons = {};
		this.grid_buttons = this.wrapper.find(".grid-buttons");
		this.grid_custom_buttons = this.wrapper.find(".grid-custom-buttons");
		this.remove_rows_button = this.grid_buttons.find(".grid-remove-rows");
		this.remove_all_rows_button = this.grid_buttons.find(".grid-remove-all-rows");

		this.setup_allow_bulk_edit();
		this.setup_check();
		if (this.df.on_setup) {
			this.df.on_setup(this);
		}
	}

	setup_add_row() {
		this.wrapper.find(".grid-add-row").click(() => {
			this.add_new_row(null, null, true, null, true);
			this.set_focus_on_row();

			return false;
		});
	}

	add_new_row(idx, callback, show, copy_doc, go_to_last_page = false, go_to_first_page = false) {
		if (this.is_editable()) {
			if (go_to_last_page) {
				this.grid_pagination.go_to_last_page_to_add_row();
			} else if (go_to_first_page) {
				this.grid_pagination.go_to_page(1);
			}

			if (this.frm) {
				var d = frappe.model.add_child(
					this.frm.doc,
					this.df.options,
					this.df.fieldname,
					idx
				);
				if (copy_doc) {
					d = this.duplicate_row(d, copy_doc);
				}
				d.__unedited = true;
				this.total_count = this.total_count + 1
				d.idx = this.total_count
				this.data.push(d)
				this.frm.script_manager.trigger(this.df.fieldname + "_add", d.doctype, d.name);
				this.refresh();
			} else {
				if (!this.df.data) {
					this.df.data = this.get_data() || [];
				}
				this.df.data.push({ idx: this.df.data.length + 1, __islocal: true });
				this.refresh();
			}

			if (show) {
				if (idx) {
					// always open inserted rows
					this.wrapper
						.find("[data-idx='" + idx + "']")
						.data("grid_row")
						.toggle_view(true, callback);
				} else {
					if (!this.allow_on_grid_editing()) {
						// open last row only if on-grid-editing is disabled
						this.wrapper
							.find(".grid-row:last")
							.data("grid_row")
							.toggle_view(true, callback);
					}
				}
			}

			return d;
		}
	}

	refresh() {
		if (this.frm && this.frm.setting_dependency) return;

		this.filter_applied = Object.keys(this.filter).length !== 0;
		this.data = this.get_data(this.filter_applied);

		!this.wrapper && this.make();
		let $rows = $(this.parent).find(".rows");

		this.setup_fields();

		if (this.frm) {
			this.display_status = frappe.perm.get_field_display_status(
				this.df,
				this.frm.doc,
				this.perm
			);
		} else if (this.df.is_web_form && this.control) {
			this.display_status = this.control.get_status();
		} else {
			// not in form
			this.display_status = "Write";
		}

		if (this.display_status === "None") return;

		// redraw
		this.make_head();

		if (!this.grid_rows) {
			this.grid_rows = [];
		}

		this.truncate_rows();
		this.grid_rows_by_docname = {};

		this.grid_pagination.update_page_numbers();
		this.render_result_rows($rows, false);
		this.grid_pagination.check_page_number();
		this.wrapper.find(".grid-empty").toggleClass("hidden", Boolean(this.data.length));

		// toolbar
		this.setup_toolbar();
		this.toggle_checkboxes(this.display_status !== "Read");

		// sortable
		if (this.is_sortable() && !this.sortable_setup_done) {
			this.make_sortable($rows);
			this.sortable_setup_done = true;
		}

		this.last_display_status = this.display_status;
		this.last_docname = this.frm && this.frm.docname;

		// red if mandatory
		this.form_grid.toggleClass("error", !!(this.df.reqd && !(this.data && this.data.length)));

		this.refresh_remove_rows_button();

		this.wrapper.trigger("change");
	}

    render_result_rows($rows, append_row) {
		let result_length = this.grid_pagination.get_result_length();
		let page_index = this.grid_pagination.page_index;
		let page_length = this.grid_pagination.page_length;
		if (!this.grid_rows) {
			return;
		}
		let me = this;
		frappe.run_serially([
			() =>{return},
			() => {
				for (var ri = 0; ri < page_length; ri++) {
					var d = me.data[ri];
					if (!d) {
						return;
					}
					if (d.idx === undefined) {
						d.idx = ri + 1;
					}
					if (d.name === undefined) {
						d.name = "row " + d.idx;
					}
					if (me.grid_rows[ri] && !append_row) {
						var grid_row = me.grid_rows[ri];
						grid_row.doc = d;
						grid_row.refresh();
					} else {
						var grid_row = new ServersideGridRow({
							parent: $rows,
							parent_df: me.df,
							docfields: me.docfields,
							doc: d,
							frm: me.frm,
							grid: me,
						});
						me.grid_rows[ri] = grid_row;
					}
		
					me.grid_rows_by_docname[d.name] = grid_row;
				}
			},
		]);
    }

	get_data(filter_field) {
		if (!filter_field && this.data){
			return this.data;
		}
		let data = [];
		data = this.get_filtered_data();
		return data
	}

	get_filtered_data() {
		let filtered_data = [];
		let page_index = 1;
		let page_length = 10;

		if(this.grid_pagination){
			page_index = this.grid_pagination.page_index;
			page_length = this.grid_pagination.page_length;
		}

		let me = this;
		frappe.call({
			method: "frappe.desk.search.get_filtered_data",
			args: {
				doctype: this.frm.doc.doctype,
				docname: this.frm.doc.name,
				child_table_fieldname: this.df.fieldname,
				filters: this.filter,
				page_length: page_length,
				page_index:page_index
			},
			async: false,  // 👈 deprecated and risky
			freeze:true,
			callback: function(r) {
				if (r.message) {
					filtered_data = r.message.data;
					me.data = r.message.data;
					me.total_count = r.message.total_count;
					if(me.grid_pagination){
						me.grid_pagination.update_page_numbers();
					}
					
					
					filtered_data.forEach(d => {
						// Ensure the doctype container exists
						if (!locals[d.doctype]) {
							locals[d.doctype] = {};
						}
				
						// If the document is not already in locals, add it
						if (!locals[d.doctype][d.name]) {
							locals[d.doctype][d.name] = d;
						}
					});
				}
			}
		});
	
		return filtered_data;
	}
}

export default ServersideGrid;